import React from 'react';

import Menu from '..//Menu/Menu';
import Hamburger from '../Icons/Hamburger';

import './Header.css';

const Header = (props) => {

		return (
		  <div className='header'>
		    <h1 className='header-title'>Krachtenveldanalyse:</h1>
      	<input
      		className='inputName'
	    		type='text'
	        value={props.name}
	    		placeholder='titel'
	    		onChange={props.handleChangeTitle}
  			/>
		    <button
		    	className='hamburgerbutton'
		    	onClick={props.handleClickHamburger}>
		    	<Hamburger />
	    	</button>
		    <Menu
          items={props.items}
          status={props.status}
          handleClickMenu={props.handleClickMenu}
          handleClickSave={props.handleClickSave}
          handleClickOpen={props.handleClickOpen}
          handleClickPrint={props.handleClickPrint}
        />
		  </div>
		)
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js